module.exports = __webpack_public_path__ + "img/structured-resumes.65436b84.svg";